import "core-js/modules/es6.array.slice.js";
export default function capitalize(val) {
  return val.charAt(0).toUpperCase() + val.slice(1);
}